export default __webpack_public_path__ + "static/fa-regular-400-c614b37fa57735255e44256ada628793.eot";